"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getPortalPoiTotalCount = function getPortalPoiTotalCount(portalId) {
  return {
    type: 'POIS_TOTAL_COUNT_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {}
  };
};

var usePortalPoiCount = function usePortalPoiCount(_ref) {
  var portalId = _ref.portalId,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  return (0, _reactQuery.useQuery)(['portal', portalId, 'poi', 'totalCount'], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, body;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(getPortalPoiTotalCount(portalId));

          case 2:
            _yield$request = _context.sent;
            body = _yield$request.body;
            return _context.abrupt("return", body === null || body === void 0 ? void 0 : body.totalCount);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), options);
};

var _default = usePortalPoiCount;
exports["default"] = _default;